<div class="row">
  <div class="col s12 m6">
    <h4 class="card-title">Dashboard</h4>
  </div>
</div>
<div class="row">
  <div class="col s12 m3">
    <input (dateTimeChange)="dateChange($event)" [(ngModel)]="selectedMoment" [selectMode]="'range'" [owlDateTime]="dt1" style="width: 220px;">
    <span class="trigger" [owlDateTimeTrigger]="dt1">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
  </div>
  <div class="col s12 m3">
    <input (dateTimeChange)="compareDateChange($event)" [(ngModel)]="compareSelectedMoment" [selectMode]="'range'" [owlDateTime]="dt2" style="width: 220px;">
    <span class="trigger" [owlDateTimeTrigger]="dt2">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
  </div>

  <div class="col s12 m3">
    <i class="material-icons prefix">dashboard</i>
    <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mr-1 mb-2'
      href='#' data-target='ddl_format' style="min-width:150px; margin-left: 22px; background-color: #bbf0ee;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="formatSelected">{{formatSelected.title}}</span>
    </a>
    <ul id='ddl_format' class='dropdown-content'>
      <li (click)="formatSelect(rec)" *ngFor="let rec of formats; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec.value}}</a>
      </li>
    </ul>
  </div>

  <div class="col s12 m3" style="display: flex; justify-content: flex-end; align-items: center;">
    <!-- <i (click)="pageData.autoRefresh = !pageData.autoRefresh" class="material-icons tatt-i-btn mr-1" [ngClass]="{'icon-light-blue': pageData.autoRefresh}">refresh</i> -->
    <a class='hide dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mb-2' href='#' data-target='ddl_dashboard_areas' style="min-width:158px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="!area">-- ALL --</span>
      <span *ngIf="area">{{area.areaName}}</span>
    </a>
    <!-- Dropdown Structure -->
    <ul id='ddl_dashboard_areas' class='dropdown-content'>
      <li (click)="areaSelect(rec)" *ngFor="let rec of pageData.areas; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec.areaName}}</a>
      </li>
    </ul>
    <div style="max-width: 400px;">
      <select class="ddl-001" (change)="areaSelectDdl($event.target.value)">
        <option *ngFor="let rec of pageData.areas; let iRec = index;" [ngValue]="iRec">{{rec.areaName}}</option>
      </select>
    </div>
  </div>
</div>
<div>
  
<div class="row">
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.maxOccupancy}}</h5>
          <p class="no-margin">Max Occupancy</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-deep-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.maxOccupancy>0">{{dataHis.maxOccupancy}}</span>
            <span *ngIf="dataHis.maxOccupancy<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.inValue}}</h5>
          <p class="no-margin">Entry Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-shadow gradient-45deg-light-blue-cyan white-text">people</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.inValue>0">{{dataHis.inValue}}</span>
            <span *ngIf="dataHis.inValue<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 14 hide" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}" *ngIf="pageData.isToday">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.outValue}}</h5>
          <p class="no-margin">Exit Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-deep-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">
            <span *ngIf="dataHis.outValue>0">{{dataHis.outValue}}</span>
            <span *ngIf="dataHis.outValue<=0">-</span>
          </p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  
  <div class="col s12 14" [ngClass]="{'m3': isShowDTD, 'm4': !isShowDTD}">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{peakHourTitle}}</h5>
          <p class="no-margin">Peak Hour</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-deep-orange-orange gradient-shadow white-text">timer</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">{{dataHis.peakHourTitle}}</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isShowDTD" class="col s12 m3 14">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{dwelltimeMinute/60 | number:'1.1-1'}}  Min</h5>
          <p class="no-margin">Dwell Time</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-deep-white-white gradient-shadow white-text">timer</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">{{dwelltimeMinuteLastWeek/60 | number:'1.1-1'}}  Min</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m4 l4 hide">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0"></h4>
        <p class="medium-small"></p>
        <div class="pnl-chart-pie-01">
          <div class="chart-pie-01"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  
  <div class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtOrders" #pdfchtOrders>
        <div class="row">
          <div class="col s6">
            <h4 class="card-title mb-0">Daily Entry</h4></div>
          <div class="col s6">
          <a (click)="downloadAsPDF('chtOrders')" class="card-title waves-effect waves-light gradient-45deg-grey-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtOrders" #chtOrders class="chart-canvas"></canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m12">
    <div *ngIf="isLoading">
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-blue-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtTe" #pdfchtTe>
        <div class="row">
          <div class="col s6">
            <h4 class="card-title mb-0">Top Entrances</h4></div>
          <div class="col s6">
            <!-- <a (click)="downloadAsPDF('chtTe')" class="card-title waves-effect waves-light gradient-45deg-grey-teal btn ml-1 right">
            Export PDF
          </a> -->
          <a (click)="downloadAsPDF('chtTe')" class="card-title waves-effect waves-light gradient-45deg-grey-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div class="chart-container" style="position: relative; margin-top: 15px; margin-left: 18px;">
          <canvas #chtTe id="chtTe" class="chart-canvas"></canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m12 14 hide">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtLineExit" #pdfchtLineExit>
        <div class="row">
          <div class="col s6"><h4 class="card-title mb-0">Hourly Exit</h4></div>
          <div class="col s6"><a (click)="downloadAsPDF('chtLineExit')" class="card-title waves-effect waves-light gradient-45deg-green-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtLineExit" #chtLineExit></canvas>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m12 14 hide">
    <div class="card animate fadeleft">
      <div class="card-content" id="pdfchtLineOccupancy" #pdfchtLineOccupancy>
        <div class="row">
          <div class="col s6"><h4 class="card-title mb-0">Hourly Occupancy</h4></div>
          <div class="col s6"><a (click)="downloadAsPDF('chtLineOccupancy')" class="card-title waves-effect waves-light gradient-45deg-green-teal btn ml-1 right">
            Export PDF
          </a>
          </div>
        </div>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas id="chtLineOccupancy" #chtLineOccupancy></canvas>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isShowDTD" class="col s12 m12 14">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0">Hourly Dwell Time</h4>
        <div style="position: relative; height:200px; width:100%; margin-top: 15px;">
          <canvas #chtLineHourlyDwellTime></canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col s12 m12 14">
    <div class="card shadow">
      <div class="card-header border-0">
          <div class="row">
            <div class="col s6">
              <h4 class="card-title mb-0">Daily Breakdown</h4>
            </div>
            <div class="col s6">
              <a (click)="downloadTblAsPDF()" class="btn btn-sm btn-primary card-title mt-2 mb-0 right">
              Export PDF
            </a>
            <a href="javascript:void(0)" (click)="dataExportCsv()" class="btn btn-sm btn-primary card-title mt-2 mb-0 mr-2 right">CSV</a>
            </div>
          </div>
      </div>
      <div class="table-responsive" id="pdfTable" #pdfTable>
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th style="width: 25%;" scope="col">Day</th>
              <th style="width: 25%;" scope="col">Traffic</th>
              <th style="width: 25%;" scope="col">Compare Day</th>
              <th style="width: 25%;" scope="col">Compare Traffic</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rec of dataLevel4">
              <td>{{rec.d}}</td>
              <td>{{rec.t}}</td>
              <td>{{rec.hd}}</td>
              <td>{{rec.ht == 0 ? '' : rec.ht}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>